import { GetterTree } from 'vuex'
import { split, head, last, pipe, filter, lowerCase } from 'lodash/fp'
import { TechpackState } from './techpack.model'
import { TechpackAttachment } from '@/graphql/generated/types'

const supportedPreviews = ['jpg', 'jpeg', 'jfif', 'pjpeg', 'pjp', 'png', 'svg', 'pdf']

const getFileExtension = pipe(split('?'), head, split('.'), last, lowerCase)

const canPreview = (attachment: TechpackAttachment): boolean => {
  const fileExtension = getFileExtension(attachment.link)
  return supportedPreviews.some(ext => ext === fileExtension)
}

const filterPreviewable = filter(canPreview)
const filterNonPreviewable = filter((att: TechpackAttachment) => !canPreview(att))

export enum GetterTypes {
  GET_TECHPACK_SHARE = 'GET_TECHPACK_SHARE',
  GET_TECHPACK_SHARE_ATTACHMENTS_PREVIEW = 'GET_TECHPACK_SHARE_ATTACHMENTS_PREVIEW',
  GET_TECHPACK_SHARE_ATTACHMENTS_NONPREVIEW = 'GET_TECHPACK_SHARE_ATTACHMENTS_NONPREVIEW'
}

export const getters: GetterTree<TechpackState, unknown> = {
  [GetterTypes.GET_TECHPACK_SHARE](state) {
    return state.techpack
  },
  [GetterTypes.GET_TECHPACK_SHARE_ATTACHMENTS_PREVIEW](state) {
    return filterPreviewable(state.techpack?.attachments)
  },
  [GetterTypes.GET_TECHPACK_SHARE_ATTACHMENTS_NONPREVIEW](state) {
    return filterNonPreviewable(state.techpack?.attachments)
  }
}
